export default {
  fields: {
    sales: {
      label: 'Vendite',
    },
    gift_cards_sales: {
      label: 'Vendite gift card',
    },
    average_order_value: {
      label: 'Valore medio ordine',
    },
    savings: {
      label: 'Risparmio su commissioni di terzi',
    },
    reservations: {
      label: 'Prenotazioni',
    },
    sales_from_email: {
      label: 'Vendite da Email',
    },
    sales_from_google_seo: {
      label: 'Vendite da Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Vendite da Google Business',
    },
    sales_from_google_ads: {
      label: 'Vendite da Google Ads',
    },
    sales_from_flyers: {
      label: 'Vendite da volantini',
    },
    sales_from_social_media: {
      label: 'Vendite da social media',
    },
    sales_from_facebook_ads: {
      label: 'Vendite da Facebook Ads',
    },
    tips: {
      label: 'Mance',
    },
    new_customers: {
      label: 'Nuovi clienti',
    },
    returning_customers: {
      label: 'Clienti di ritorno',
    },
    new_visitors: {
      label: 'Nuovi visitatori',
    },
    new_followers: {
      label: 'Nuovi follower',
    },
    total_followers: {
      label: 'Follower totali',
    },
    delivered_messages: {
      label: 'Messaggi consegnati',
    },
    average_open_rate: {
      label: 'Tasso medio di apertura email',
    },
    average_click_rate: {
      label: 'Tasso di clic medio',
    },
    website_visitors_from_email: {
      label: 'Visitatori sito da Email',
    },
    sales_from_google_business: {
      label: 'Vendite da Google Business',
    },
    total_reservations: {
      label: 'Prenotazioni',
    },
    website_visitors_from_google_seo: {
      label: 'Clic sito da Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Clic sito da Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Clic sito da Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Clic sito da social media',
    },
    calls_from_google_ads: {
      label: 'Chiamate da Google Ads',
    },
    directions_from_google_ads: {
      label: 'Indicazioni da Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Social Media',
    },
    flyer_orders_count: {
      label: 'Volantini',
    },
    email_orders_count: {
      label: 'Email',
    },
    other_orders_count: {
      label: 'Altri',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Gift card',
    },
    net_billed_revenue: {
      label: 'Ricavi fatturati (NETTO)',
    },
    net_billed_revenue_subscription: {
      label: 'Ricavi abbonamento fatturati',
    },
    net_billed_revenue_service_fee: {
      label: 'Ricavi commissione servizio fatturati',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Ricavi fatturati spese di consegna',
    },
    net_billed_revenue_other: {
      label: 'Ricavi fatturati addebiti di servizio',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Consegna fatturata - Pass-through',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Ricavi fatturati commissioni elaborazione',
    },
    gross_cash_income: {
      label: 'Entrate in contanti (Lordo)',
    },
    gross_cash_income_subscription: {
      label: 'Entrate in contanti da abbonamenti',
    },
    gross_cash_income_service_fee: {
      label: 'Entrate in contanti da commissioni servizio',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Entrate in contanti da spese consegna',
    },
    gross_cash_income_other: {
      label: 'Entrate in contanti da addebiti servizio',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Entrate in contanti da commissioni pass-through',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Entrate in contanti da commissioni piattaforma',
    },
    net_cash_income: {
      label: 'Entrate in contanti (Netto)',
    },
    net_cash_income_subscription: {
      label: 'Entrate in contanti da abbonamenti',
    },
    net_cash_income_service_fee: {
      label: 'Entrate in contanti da commissioni servizio',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Entrate in contanti da spese consegna',
    },
    net_cash_income_other: {
      label: 'Entrate in contanti da addebiti servizio',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Entrate in contanti da commissioni pass-through',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Entrate in contanti da commissioni piattaforma',
    },
    manual_connect_transfers: {
      label: 'Rimborsato ai ristoranti',
    },
    processing_fees: {
      label: 'Commissioni di elaborazione',
    },
    processing_fees_stripe: {
      label: 'Commissioni di elaborazione (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Commissioni di elaborazione (PayPal)',
    },
    rejected_orders: {
      label: 'Ordini rifiutati',
    },
    rejected_orders_amount: {
      label: 'Importo ordini rifiutati',
    },
    rejected_orders_count: {
      label: 'Numero ordini rifiutati',
    },
    rejected_orders_rate: {
      label: 'Tasso ordini rifiutati',
    },
    rejected_orders_rate_breakdown: {
      label: 'Dettaglio tasso ordini rifiutati',
    },
    orders: {
      label: 'Ordini',
    },
    total_orders: {
      label: 'Ordini totali',
    },
    pickup_orders_rate: {
      label: 'Tasso ordini con ritiro',
    },
    delivery_orders_rate: {
      label: 'Tasso ordini con consegna',
    },
    other_orders_rate: {
      label: 'Tasso altri ordini',
    },
    customers: {
      label: 'Clienti totali',
    },
    customers_auth_state: {
      label: 'Stato autenticazione clienti',
    },
    website_reservations: {
      label: 'Prenotazioni sito web',
    },
    google_reservations: {
      label: 'Prenotazioni Google',
    },
    companies: {
      label: 'Aziende',
    },
    live_companies: {
      label: 'Ristoranti attivi',
    },
    live_companies_percentage: {
      label: 'Percentuale ristoranti attivi',
    },
    setup_packages_breakdown: {
      label: 'Pacchetti di configurazione',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Pacchetti di configurazione per fonte fatturazione',
    },
    crossed_sales_level_this_month: {
      label: 'Soglia vendite superata questo mese',
    },
    crossed_sales_level_total: {
      label: 'Soglia vendite superata totale',
    },
    crossed_sales_level_percentage: {
      label: 'Percentuale soglia vendite superata',
    },
    has_delivery: {
      label: 'Consegna propria',
    },
    has_only_pickup: {
      label: 'Solo ritiro',
    },
    has_storefront: {
      label: 'Con vetrina',
    },
    has_storefront_percentage: {
      label: 'Percentuale vetrina',
    },
    use_external_delivery: {
      label: 'Consegna esterna',
    },
    crossed_sales: {
      label: 'Superato {{value}} vendite',
    },
    restaurant_partners: {
      label: 'Ristoranti partner',
    },
    registered_restaurants: {
      label: 'Ristoranti registrati',
    },
    signed_restaurants: {
      label: 'Ristoranti con contratto',
    },
    use_reservations: {
      label: 'Usa prenotazioni',
    },
    number: {
      label: 'Numero',
    },
    restaurants_percentage: {
      label: 'Percentuale ristoranti',
    },
    crossed_sales_level: {
      label: 'Soglia vendite superata',
    },
    order_method: {
      label: 'Metodo ordine',
    },
    own_delivery: {
      label: 'Consegna propria',
    },
    only_pickup: {
      label: 'Solo ritiro',
    },
    storefront: {
      label: 'Vetrina',
    },
    sales_tiers: {
      label: 'Livelli di vendita',
    },
    new_pricing_adoption_rate: {
      label: 'Tasso adozione nuovo pricing',
    },
    mobile_app_attach_rate: {
      label: 'Tasso adozione app mobile',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Commissioni configurazione app mobile scelte',
    },
    first_delivery: {
      label: 'Uber (Prima consegna)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Numero preventivi consegna',
    },
    deliveries_count: {
      label: 'Numero consegne',
    },
    delivery_conversion: {
      label: 'Tasso di conversione consegna',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Dettaglio fornitori preventivi consegna',
    },
    deliveries_provider_breakdown: {
      label: 'Dettaglio fornitori consegne',
    },
    delivery_distance_breakdown: {
      label: 'Dettaglio distanza di consegna',
    },
    total_delivered: {
      label: 'Messaggi consegnati',
    },
    website_visitors_from_google_business_profile: {
      label: 'Click sul sito da Google Business',
    },
    google_business_impressions: {
      label: 'Impressioni da Google Business',
    },
    google_business_website_clicks: {
      label: 'Click sul sito da Google Business',
    },
    google_ads_impressions: {
      label: 'Impressioni Google Ads',
    },
    google_ads_clicks: {
      label: 'Click Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Chiamate Google Ads',
    },
    google_ads_directions: {
      label: 'Indicazioni stradali Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: '% media impressioni assolute in cima Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Costo medio per click Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Tasso medio conversioni da interazioni Google Ads',
    },
    website_visits: {
      label: 'Visite al sito',
    },
    website_visitors: {
      label: 'Visitatori del sito',
    },
    companies_with_activated_reservations: {
      label: 'Ristoranti con prenotazioni attivate',
    },
    online_orders_count: {
      label: 'Ordini online',
    },
    cash_orders_count: {
      label: 'Ordini online',
    },
    cash_sales: {
      label: 'Vendite in contanti',
    },
    online_sales: {
      label: 'Vendite online',
    },
    payouts: {
      label: 'Pagamenti',
    },
    last_payout_amount: {
      label: 'Ultimo pagamento',
    },
    pending_payout_amount: {
      label: 'In transito',
    },
    future_payout_amount: {
      label: 'Disponibile per pagamenti futuri',
    },
    mobile_app_average_order_value: {
      label: 'AOV tramite App',
    },
    mobile_app_gmv: {
      label: 'Vendite totali tramite App',
    },
    mobile_app_gmv_percentage: {
      label: '% ricavi da App',
    },
    mobile_app_downloads: {
      label: "Download totali dell'App",
    },
    mobile_app_orders_count: {
      label: 'Ordini totali tramite App',
    },
    net_billed_revenue_gift_cards: {
      label: 'Ricavi fatturati da gift card',
    },
    gross_cash_income_gift_cards: {
      label: 'Entrate in contanti da gift card',
    },
    net_cash_income_gift_cards: {
      label: 'Entrate in contanti da gift card',
    },
    platform_processing_fees: {
      label: 'Commissioni di elaborazione piattaforma',
    },
  },
};
